import { handleActions, createAction } from 'redux-actions';

export const BETS_INPUT_INITIAL = createAction('BETS/INPUT/INITIAL');
export const USER_TYPED_VALID_BET = createAction('USER/TYPED/VALID/BET');
export const USER_TYPED_INVALID_BET = createAction('USER/TYPED/INVALID/BET');

const initialState = {
  valid: false,
  initial: true,
};

const betsFormValidationReducer = handleActions(
  {
    [BETS_INPUT_INITIAL]: (state) => {
      return { ...state, valid: false, initial: true, };
    },
    [USER_TYPED_VALID_BET]: (state) => {
      return { ...state, valid: true, initial: false, };
    },
    [USER_TYPED_INVALID_BET]: (state) => {
      return { ...state, valid: false, initial: false, };
    },
  },
  initialState
);

export default betsFormValidationReducer;
